export default function ProductError({

    message

}){

    return(

        <div className="container">

            <h2>

                Product not found

            </h2>

            <p>

                {message}

            </p>

        </div>

    )

}